var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHowItWorksLeftCurve(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 276,
    height: 205,
    viewBox: "0 0 276 205",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16145 0.9997C2.96813 20.3895 0.654572 40.8093 2.35285 61.0932C4.05113 81.3771 9.72798 101.128 19.0593 119.218C28.3906 137.308 41.1937 153.383 56.7374 166.525C72.2812 179.667 90.2613 189.619 109.651 195.812C129.041 202.005 149.461 204.319 169.745 202.621C190.029 200.922 209.779 195.245 227.869 185.914C245.959 176.583 262.034 163.78 275.176 148.236",
    stroke: "#FADAC8",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowItWorksLeftCurve);
export default __webpack_public_path__ + "static/media/howItWorksLeftCurve.5e47bd38330502a233fef44e0dc86552.svg";
export { ForwardRef as ReactComponent };